import {
  spacex,
  persica,
  holidaze,
  frontalex,
  reactprojects,
  moderngpt,
  plantex,
  travel,
} from "./imports";

export const ProjectItems = {
  1: {
    title: "SpaceX",
    type: "School Project",
    hexColor: "06183E",
    url: "https://spacex-projectexam.vercel.app/",
    gitUrl: "https://github.com/alexandra-ep/spacex-project",
    image: spacex,
    tags: [
      {
        name: "Design",
      },
      {
        name: "HTML",
      },
      {
        name: "CSS",
      },
      {
        name: "JavaScript",
      },
      {
        name: "API",
      },
      {
        name: "Responsive",
      },
    ],
    description:
      "This was my first project exam at Noroff where I received a B. For this project exam we were to plan and create a microsite for SpaceX to raise awareness about space program activity around the world. I chose to use their API documents to create a responsive microsite focusing on the next launches and the goals of SpaceX. I designed the website using Adobe XD and created the website using HTML, CSS, and JS.",
  },
  2: {
    title: "PERSICA",
    type: "School Project",
    hexColor: "E4A15D",
    url: "https://persica-skincare.vercel.app/",
    gitUrl: "https://github.com/alexandra-ep/persica",
    image: persica,
    tags: [
      {
        name: "Design",
      },
      {
        name: "Brand Identification",
      },
      {
        name: "Responsive",
      },
      {
        name: "HTML",
      },
      {
        name: "Sass",
      },
      {
        name: "JavaScript",
      },
      {
        name: "API",
      },
      {
        name: "Bootstrap",
      },
      {
        name: "Strapi",
      },
    ],
    description:
      "This was my second semester project at Noroff where I received a B. For this semester project we were to create a responsive e-commerce website that had both customer-facing and admin sections. We could decide the theme ourselves, and I chose to create a website for PERSICA - a skincare brand focusing on organic products. I created the logo, hero banner, and all the products in Adobe Illustrator, and designed the website in Adobe XD. We were also required to make a style guide and functional requirements that I chose to write in the form of 'System-Must-Haves'. The website was created with HTML, Sass and JS.",
  },
  3: {
    title: "holidaze",
    type: "School Project",
    hexColor: "3B527A",
    url: "https://holidaze-norway.vercel.app/",
    gitUrl: "https://github.com/alexandra-ep/holidaze",
    image: holidaze,
    tags: [
      {
        name: "Design",
      },
      {
        name: "Brand Identification",
      },
      {
        name: "Responsive",
      },
      {
        name: "ReactJS",
      },
      {
        name: "Sass",
      },
      {
        name: "Bootstrap",
      },
      {
        name: "Strapi",
      },
      {
        name: "BEM",
      },
      {
        name: "API",
      },
    ],
    description:
      "This was my last and final exam project at Noroff where I received an A. For this project we were to take the skills we had learned over the past two years and create a finished product that reflected our general development capabilities, and visual, and technical skills. The task was to create a hotel booking website for a local tourism agency in Bergen. The finished website has two sides - visitor and admin - and both reflects my capabilities as a front-end developer. I created the logo with Adobe Illustrator and I designed the website with Adobe XD. The website was created with ReactJS and Sass.",
  },
  4: {
    title: "Portfolio v1.0",
    type: "School Project",
    hexColor: "7AD0B2",
    url: "https://frontalex.vercel.app/",
    gitUrl: "https://github.com/alexandra-ep/frontalex-portfolio",
    image: frontalex,
    tags: [
      {
        name: "ReactJS",
      },
      {
        name: "Sass",
      },
      {
        name: "BEM",
      },
      {
        name: "Design",
      },
      {
        name: "Responsive",
      },
      {
        name: "Bootstrap",
      },
      {
        name: "EmailJS",
      },
      {
        name: "IG Feed",
      },
    ],
    description:
      "This was my first portfolio. I wanted to create a light and modern website with all my information and what I could offer as a frontend developer. I designed it in Adobe XD, and created the website with ReactJS and Sass. I also used the npm packages EmailJS for the contact form and IG Feed for the Instagram Feed.",
  },
  5: {
    title: "15 React Projects",
    type: "Learning Project",
    hexColor: "9FB9E5",
    url: "https://15-react-projects.vercel.app/",
    gitUrl: "https://github.com/alexandra-ep/15-react-projects",
    image: reactprojects,
    tags: [
      {
        name: "ReactJS",
      },
      {
        name: "Sass",
      },
      {
        name: "BEM",
      },
      {
        name: "Design",
      },
      {
        name: "Responsive",
      },
      {
        name: "API",
      },
    ],
    description:
      "This was my first project after graduating from Noroff. I wanted to keep on learning React as I find it really interesting and great to use to build websites. I followed the YouTube video 'Code 15 React Projects - Complete Course' by freeCodeCamp.org and it was a great learning experience.",
  },
  6: {
    title: "GPT-3",
    type: "Learning Project",
    hexColor: "BB71C4",
    url: "https://modern-gpt3.vercel.app/",
    gitUrl: "https://github.com/alexandra-ep/modern-website",
    image: moderngpt,
    tags: [
      {
        name: "ReactJS",
      },
      {
        name: "CSS",
      },
      {
        name: "JSX",
      },
      {
        name: "BEM",
      },
      {
        name: "Responsive",
      },
      {
        name: "Design",
      },
    ],
    description:
      "This is a landing page for GPT3 which is another learning project. The goal of making this landing page was to improve my skills in making responsive and modern websites. The website was created with ReactJS and CSS.",
  },
  7: {
    title: "PLANTEX",
    type: "Learning Project",
    hexColor: "3E6553",
    url: "https://plantex.vercel.app/",
    gitUrl: "https://github.com/alexandra-ep/plantex",
    image: plantex,
    tags: [
      {
        name: "HTML",
      },
      {
        name: "CSS",
      },
      {
        name: "JS",
      },
      {
        name: "Design",
      },
      {
        name: "Responsive",
      },
    ],
    description:
      "This is a landing page for Plantex which is another learning project. There are no real functions on the website, but it is fully responsive and has a switch to change between light and dark mode. The goal of making this landing page was to improve my skills in making responsive and modern websites. The website was created with HTML, CSS, and JS.",
  },
  8: {
    title: "Travel",
    type: "Learning Project",
    hexColor: "049399",
    url: "https://alexandraep-travel.vercel.app/",
    gitUrl: "https://github.com/alexandra-ep/travel-website",
    image: travel,
    tags: [
      {
        name: "HTML",
      },
      {
        name: "CSS",
      },
      {
        name: "JS",
      },
      {
        name: "Design",
      },
      {
        name: "Responsive",
      },
      {
        name: "Mobile First",
      },
      {
        name: "ScrollRevealJS",
      },
      {
        name: "RemixIcon",
      },
      {
        name: "SwiperJS",
      },
    ],
    description:
      "This is a landing page for Travel which is a learning project. It is a fully responsive website with several functions like light/dark mode and scroll reveal. The goal of making this website is to improve my skills in responsive design using HTML, CSS and JavaScript.",
  },
};
